import type { ReplayResult, ReplayStatus } from './replays.api';

export const ACTIVE_REPLAY_STATUSES = new Set<ReplayStatus>(['pending', 'running', 'judging']);

export const REPLAY_STATUS_VARIANT: Record<
  ReplayStatus,
  'default' | 'secondary' | 'destructive' | 'outline'
> = {
  pending: 'outline',
  running: 'secondary',
  judging: 'secondary',
  judged: 'default',
  failed: 'destructive',
  cancelled: 'outline',
  inconclusive: 'outline',
};

export const REPLAY_RESULT_VARIANT: Record<
  ReplayResult,
  'default' | 'secondary' | 'destructive' | 'outline'
> = {
  pass: 'default',
  fail: 'destructive',
  inconclusive: 'secondary',
};
